import { useLocation } from 'react-router-dom';

export const IsInfraType = () => {
  const query = new URLSearchParams(useLocation().search);
  return query.get('type') === 'infra';
};
